import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ContentLibPreview from './ContentLibPreview';
import OngoingCollabsPreview from './OngoingCollabsPreview';

const RecentCollabs = () => {

    const [activeTab, setActiveTab] = useState<"content"|"collabs">("content");

    return (
        <div className='dashboard-section'>
            <div className="dashboard-section-header">
                <h5>Recent Collaborations</h5>
                <Link className='dashboard-section-header-view-more' to={{ pathname: activeTab === 'content' ? '/content-library' : 'collaboration' }}>View All</Link>
            </div>
            <div className="dashboard-section-body">
                <div className="dashboard-section-card">
                    <div className="dashboard-section-card-header">
                        <div className="dashboard-section-nav">
                            <div className={`dashboard-section-nav-item ${activeTab === 'content' ? 'active' : ''}`} onClick={() => setActiveTab("content")}>
                                <span>Completed Collabs</span>
                            </div>
                            <div className={`dashboard-section-nav-item ${activeTab === 'collabs' ? 'active' : ''}`} onClick={() => setActiveTab("collabs")}>
                                <span>Ongoing Collabs</span>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-section-card-body">
                        {
                            activeTab === 'content' && <ContentLibPreview />
                        }
                        {
                            activeTab === 'collabs' && <OngoingCollabsPreview />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecentCollabs